import {Component, Input} from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {HistoricalValuesModel} from "../../../../domain/dao/historical-values.model";

@Component({
  selector: 'app-historical-dialog',
  templateUrl: './historical-dialog.component.html',
  styleUrls: ['./historical-dialog.component.css'],
  standalone: false
})
export class HistoricalDialogComponent {


  @Input() data: HistoricalValuesModel[] = [];

  constructor(public modal: NgbActiveModal) {
  }
}
